import React from "react";

// Serequímica logo mark – hexagonal S with beaker handle
// Colors: green background (or transparent) with gold strokes
export function LogoMark({ size = 56, gold = "#c9a24c", withBg = false, bg = "#0e3b21" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Serequímica"
      role="img"
    >
      {withBg && <rect width="120" height="120" rx="12" fill={bg} />}
      {/* Hexagon */}
      <polygon
        points="60,14 100,36 100,80 60,102 20,80 20,36"
        fill="none"
        stroke={gold}
        strokeWidth="4"
        strokeLinejoin="round"
      />
      {/* Inner circle */}
      <circle cx="60" cy="58" r="20" fill="none" stroke={gold} strokeWidth="4" />
      {/* Stylized S */}
      <path
        d="M67 50c0-3.3-2.7-6-6-6h-3c-2.8 0-5 2.2-5 5 0 2.2 1.4 4.2 3.5 4.8l7 2.2c2.3.7 4 2.8 4 5.3 0 3-2.5 5.5-5.5 5.5H59c-3.3 0-6-2.7-6-6"
        stroke={gold}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      {/* Beaker handle */}
      <path
        d="M92 78 L106 100"
        stroke={gold}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="106" cy="100" r="4" fill="none" stroke={gold} strokeWidth="4" />
    </svg>
  );
}

export function LogoLockup({ tone = "light", size = 44 }) {
  const nameColor = tone === "light" ? "#ffffff" : "#0e3b21";
  const taglineColor = tone === "light" ? "#c9a24c" : "#8a6b26";
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={size} />
      <div className="leading-none">
        <div
          style={{ color: nameColor, letterSpacing: "0.08em" }}
          className="font-extrabold text-xl sm:text-2xl"
        >
          SEREQUIMICA
        </div>
        <div
          style={{ color: taglineColor, fontFamily: "Playfair Display, serif" }}
          className="text-[10px] sm:text-[11px] italic mt-1"
        >
          Indústria e Comércio de Produtos Químicos
        </div>
      </div>
    </div>
  );
}
